import { render, staticRenderFns } from "./MorePersonalDialog.vue?vue&type=template&id=027f1946&scoped=true&"
import script from "./MorePersonalDialog.vue?vue&type=script&lang=js&"
export * from "./MorePersonalDialog.vue?vue&type=script&lang=js&"
import style0 from "./MorePersonalDialog.vue?vue&type=style&index=0&id=027f1946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f1946",
  null
  
)

export default component.exports